// @flow
import * as React from 'react'
import geocode from 'geocode'
import * as gatheringRepo from 'data/gathering'
import * as schoolRepo from 'data/school'
import { type AsyncResource, FailedToLoad } from 'framework'
import type { Address, Coordinates, Gathering, School } from 'types'
import { hit } from 'util/analytics'
import GatheringPagePresentation from './Presentation'

import './GatheringPage.scss'

type State = {
  gathering: AsyncResource<Gathering>,
  coordinates: AsyncResource<Coordinates>,
  school: AsyncResource<School>,
}

type Props = {
  gatheringId: number,
}

export default class GatheringPageContainer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      coordinates: undefined,
      gathering: undefined,
      school: undefined,
    }
  }

  componentDidMount = () => {
    this.loadGathering(this.props.gatheringId)
  }

  componentWillReceiveProps = (nextProps: Props) => {
    if (nextProps.gatheringId !== this.props.gatheringId) {
      this.loadGathering(nextProps.gatheringId)
    }
  }

  loadGathering = (gatheringId: number) => {
    this.setState({ gathering: undefined })
    gatheringRepo
      .fetch(this.props.gatheringId)
      .then(gathering => {
        hit({ gatheringId })
        this.setState({ gathering })
        this.loadSchool(gathering.schoolId)
        this.geocode(gathering.address)
      })
      .catch(() => this.setState({ gathering: FailedToLoad }))
  }

  loadSchool = (schoolId: number) => {
    if (this.state.school && this.state.school.id === schoolId) return

    this.setState({ school: undefined })
    schoolRepo
      .fetch(schoolId)
      .then(school => this.setState({ school }))
      .catch(() => this.setState({ school: FailedToLoad }))
  }

  geocode = (address: ?Address) => {
    if (!address) {
      this.setState({ coordinates: FailedToLoad })
      return
    }

    const location = [address.line1, address.city, address.state, address.postalCode]
      .filter(val => val)
      .join(', ')

    geocode(location).then(({ lat, lng }) => {
      const coordinates = lat && lng ? { lat, lng } : FailedToLoad
      this.setState({ coordinates })
    })
  }

  render = () => {
    return (
      <GatheringPagePresentation
        gathering={this.state.gathering}
        coordinates={this.state.coordinates}
        school={this.state.school}
      />
    )
  }
}
